module.exports = new __parcel__URL__("notion-logomark.fa29cc5e.svg").toString();